import type { MaybeRefOrGetter } from "vue";

import { computed, toValue } from "vue";

function useSuffixIcon({
  loading,
  displayValidating,
  displayValid,
  displayInvalid,
  suffixIcon,
  showValidState,
}: {
  displayInvalid?: MaybeRefOrGetter<boolean>;
  displayValid?: MaybeRefOrGetter<boolean>;
  displayValidating?: MaybeRefOrGetter<boolean>;
  loading?: MaybeRefOrGetter<boolean>;
  showValidState?: MaybeRefOrGetter<boolean>;
  suffixIcon?: MaybeRefOrGetter<string | undefined>;
}) {
  return computed(() => {
    if (toValue(loading) || toValue(displayValidating)) {
      return "fa-regular fa-spinner-third fa-spin";
    }
    if (toValue(suffixIcon)) {
      return toValue(suffixIcon);
    }
    if (toValue(displayValid) && toValue(showValidState)) {
      return "fa-regular fa-check";
    }
    if (toValue(displayInvalid)) {
      return "fa-regular fa-exclamation-circle";
    }
    return undefined;
  });
}

export { useSuffixIcon };
